import { render, staticRenderFns } from "./LectureVideoView.vue?vue&type=template&id=760b3e62&"
import script from "./LectureVideoView.vue?vue&type=script&lang=ts&"
export * from "./LectureVideoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports